<template>

  <t-page>

    <TypeMoldDialog :no-option-add="noOptionAdd" @onSubmit="onTypeMoldDialog"/>
    <StockMoldLocationDialog :no-option-add="noOptionAdd" @onSubmit="onStockMoldLocationDialog"/>

    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <template #default="{status}">

        <t-input v-model="form[fieldKey]" hidden/>

        <t-form-tab title="Dados Básicos">


          <b-row>

            <t-input v-model="form.name"  :add-error="error.name" label="Descrição" cols="9" required/>


            <t-input v-model="form.moldCodeLabel" :add-error="error.moldCodeLabel" upper cols="3"
                     label="Cód. Molde" required/>

          </b-row>



          <t-input v-model="form.typeMoldId"
                   :options="typeMoldOptions" :add-error="error.typeMoldId"
                   label="Tipo" required select>

            <template #no-options="{search}">
              <b-link @click="addNoOption('modal-type-mold',search)">Cadastrar novo Tipo de Molde</b-link>
            </template>

            <template #input-group-append>
              <t-button title="Adicionar Tipo de Molde" @click="openDialogForm('modal-type-mold')" icon-plus/>
            </template>

          </t-input>

          <t-input v-model="form.stockPlaceMoldInsideId"
                   :options="stockLocationOptions"
                   :add-error="error.stockPlaceMoldInsideId"
                   label="Local de Estoque" required select>

            <template #no-options="{search}">
              <b-link @click="addNoOption('modal-stock-mold-location',search)">Cadastrar novo Local de Estoque</b-link>
            </template>

            <template #input-group-append>
              <t-button title="Adicionar Local de Estoque" @click="openDialogForm('modal-stock-mold-location')"
                        icon-plus/>
            </template>
          </t-input>

          <!--ATENÇÃO NÃO ESQUECER DE UTILIZAR template #default="{status} para funcionamento correto-->
          <t-page-form-field-customized
              ref="fieldsGeneral"
              :command="command" :status="status" :user-auth="userAuth"
              :fields-customizable="entityFieldCustomized('page')"
              :primary-key="form.lotId" :foreign-key="currentPage.pageId" :busy="!pageFormIsLoaded"
              :primary-key-column="fieldKey" foreign-key-column="pageId"
          />

          <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

          <t-input-status v-model="form.status" class="mb-2"/>

        </t-form-tab>

      </template>


      <template #out-of-form>

        <t-form-tab title="Imagens" hash="image" :disabled="!relationAccessPageGeneral('production-mold-file')" lazy>
          <MoldFile type-image :foreign-key="form[fieldKey]"/>
        </t-form-tab>

        <t-form-tab title="Arquivos" hash="file" :disabled="!relationAccessPageGeneral('production-mold-file')" lazy>
          <MoldFile :foreign-key="form[fieldKey]"/>
        </t-form-tab>

      </template>

    </t-page-form>

  </t-page>

</template>
<script>
import typeMoldService from "@/services/modules/production/TypeMold.service";
import stockPlaceMoldInsideService from "@/services/modules/stock/StockPlaceMoldInside.service";

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import MoldFile from "@/views/modules/production/Mold/MoldFile";
import TypeMoldDialog from "@/views/modules/production/Type/TypeMoldDialog";
import StockMoldLocationDialog from "@/views/modules/stock/StockPlaceMoldLocationDialog";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  components: {MoldFile, TypeMoldDialog, StockMoldLocationDialog},
  name: 'MoldForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: true,
      fieldKey: "moldId",
      form: {
        moldId: 0,
        moldCodeLabel:"",
        typeMoldId: 0,
        stockPlaceMoldInsideId: 0,
        name: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        moldCodeLabel:"",
        typeMoldId: "",
        stockPlaceMoldInsideId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      noOptionAdd: "",
      typeMoldOptions: [],
      stockLocationOptions: []
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      await typeMoldService.selectList("").then((list) => {
        this.typeMoldOptions = list
      }).catch(error => this.responseError(error))

      await stockPlaceMoldInsideService.selectList("").then((list) => {
        this.stockLocationOptions = list
      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onTypeMoldDialog(itemInserted) {

      this.form.typeMoldId = itemInserted.value
      this.typeMoldOptions.push(itemInserted); //Simples, pois é uma lista não agrupada, caso contrário filtrar pelo groupId


    },
    onStockMoldLocationDialog(itemInserted) {

      this.form.stockPlaceMoldInsideId = itemInserted.value
      this.stockLocationOptions.push(itemInserted); //Simples, pois é uma lista não agrupada


    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>
